/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { UNSAFE_buildAboveMediaQueryCSS, UNSAFE_buildBelowMediaQueryCSS } from './build-media-query-css';
var showAboveQueries = UNSAFE_buildAboveMediaQueryCSS({
  display: 'revert'
});
var showBelowQueries = UNSAFE_buildBelowMediaQueryCSS({
  display: 'revert'
});
var defaultHiddenStyles = css({
  display: 'none'
});
/**
 * Shows the content at a given breakpoint.  By default, content is hidden.  The primary use case is for visual presentation.
 * Mix `<Show above="md">` with `<Hide above="md">` to achieve content that shifts at a breakpoint.
 *
 * Please note:
 * - This only uses `display: none` and `display: revert` to show/hide, it does not skip rendering of children trees.
 * - As this is rendered at all times, there is little performance savings here (just that this is not painted).
 */
export var Show = function Show(_ref) {
  var above = _ref.above,
    below = _ref.below,
    children = _ref.children,
    _ref$as = _ref.as,
    AsElement = _ref$as === void 0 ? 'div' : _ref$as;
  return jsx(AsElement, {
    css: [defaultHiddenStyles, above && showAboveQueries[above], below && showBelowQueries[below]]
  }, children);
};